export const bannedTagWords = [
  // Adult content
  "porn", "porno", "sex", "xxx", "erotic", "nude", "naked", "onlyfans", "nsfw", "hentai", 
  "escort", "fetish", "blowjob", "anal", "dildo", "vibratore", "sextoy", "dong", "vibrator", 
  "bdsm", "kinky", "orgasm", "masturbat", "condom", "lubricant",

  // Alcohol & substances
  "wine", "beer", "whiskey", "vodka", "gin", "rum", "tequila", "alcool", "alcol", 
  "champagne", "prosecco", "aperol", "campari", "liquore", "liquori",

  // Tobacco
  "cigarette", "cig", "tabacco", "tobacco", "marlboro", "iqos", "vape", "e-cig", 
  "juul", "puff", "sigaretta", "fumo",

  // Drugs
  "cannabis", "weed", "thc", "cbd", "hash", "droga", "droghe", "meth", "cocaine", 
  "ecstasy", "lsd", "mushroom",

  // Gambling
  "casino", "bet", "betting", "poker", "slot", "blackjack", "roulette", "bingo", 
  "gambling", "scommesse", "gratta", "vinci",

  // Weapons
  "gun", "pistol", "weapon", "knife", "coltello", "fucile", "mitra", "sparare", 
  "shooting", "airsoft", "ak-47",

  // Hate speech / offensive / racial slurs
  "nazi", "hitler", "terrorist", "bomb", "kill", "death", "suicide", "hate",
  "nigga", "nigger", "negro", "faggot", "fag", "retard", "spic", "chink", "kike", 
  "wetback", "raghead", "towelhead", "gook", "jap", "coon", "paki",
  
  // Italian racial/ethnic slurs
  "terrone", "polentone", "crucco", "marocchino", "extracomunitario", "vu cumprà",

  // Profanity (Italian)
  "merda", "cazzo", "culo", "figa", "puttana", "bastardo", "stronzo", "coglione",

  // Profanity (English)
  "fuck", "shit", "bitch", "asshole", "damn", "hell", "crap"
];

export function validateTags(tagsString) {
  if (!tagsString) return { isValid: true };

  const tags = tagsString.split(",").map(t => t.trim().toLowerCase()).filter(Boolean);

  // Check tag count
  if (tags.length > 5) {
    return { isValid: false, error: "tagLimitExceeded" };
  }

  // Check for banned words
  for (const tag of tags) {
    if (bannedTagWords.some(banned => tag.includes(banned))) {
      return { isValid: false, error: "bannedTag" };
    }
  }

  return { isValid: true };
}

export function validateWishlistName(name) {
  if (!name) return { isValid: false, error: "wishlistNameRequired" };
  
  const trimmedName = name.trim().toLowerCase();
  
  // Check for banned words in wishlist name
  if (bannedTagWords.some(banned => trimmedName.includes(banned))) {
    return { isValid: false, error: "bannedWishlistName" };
  }
  
  return { isValid: true };
}

export function getTagCount(tagsString) {
  if (!tagsString) return 0;
  return tagsString.split(",").map(t => t.trim()).filter(Boolean).length;
}